(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hone-amazon-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hone-amazon-links')) {
    class HoneAmazonLinks extends HTMLElement {
      constructor() {
        super();
        this.onCountryClick = this.onCountryClick.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }
      connectedCallback() {
        this.addEventListener('click', this.onCountryClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('hone:amazon-country-change', this.onCountryChange);
        let country = this.dataset.initialCountry;
        try { country = sessionStorage.getItem('hone-amazon-country') || country; } catch (error) {}
        this.applyCountry(country);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onCountryClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('hone:amazon-country-change', this.onCountryChange);
      }
      onCountryClick(event) {
        const option = event.target.closest('[data-amazon-country]');
        if (!option || !this.contains(option)) return;
        event.preventDefault();
        const country = option.dataset.amazonCountry;
        try { sessionStorage.setItem('hone-amazon-country', country); } catch (error) {}
        document.dispatchEvent(new CustomEvent('hone:amazon-country-change', { detail: { country } }));
        const primary = this.querySelector('[data-amazon-primary]');
        if (primary && !primary.hidden) primary.focus();
      }
      onCountryChange(event) { this.applyCountry(event.detail.country); }
      onKeydown(event) {
        if (event.key !== 'Escape') return;
        const details = this.querySelector('details');
        if (details && details.open) { details.open = false; details.querySelector('summary').focus(); }
      }
      applyCountry(country) {
        const options = Array.from(this.querySelectorAll('[data-amazon-country]'));
        const option = options.find(item => item.dataset.amazonCountry === country);
        const primary = this.querySelector('[data-amazon-primary]');
        const name = this.querySelector('[data-amazon-country-name]');
        const separator = this.querySelector('[data-amazon-separator]');
        const change = this.querySelector('[data-amazon-change-text]');
        if (option) {
          primary.href = option.href; primary.hidden = false;
          primary.querySelector('[data-amazon-link-text]').textContent = option.dataset.amazonLinkLabel;
          primary.setAttribute('aria-label', option.dataset.amazonLinkLabel + ': ' + this.dataset.productTitle + '. ' + this.dataset.newTabLabel);
          name.textContent = option.dataset.amazonCountryLabel; name.hidden = false; separator.hidden = false; change.textContent = this.dataset.changeLabel;
        } else {
          primary.hidden = true; primary.removeAttribute('href'); name.hidden = true; separator.hidden = true; change.textContent = this.dataset.chooseLabel;
        }
        options.forEach(item => { if (item === option) item.setAttribute('aria-current', 'true'); else item.removeAttribute('aria-current'); });
        this.dataset.currentCountry = option ? country : '';
        this.querySelector('details').open = false;
      }
    }
    customElements.define('hone-amazon-links', HoneAmazonLinks);
  }
  } catch(e) { console.error(e); }
})();

})();
